<template>
  <div>
    <base-header class="pb-6 pb-8 pt-5 pt-md-8 bg-gradient-primary">
      <!-- Card stats -->
      <b-row> </b-row>
    </base-header>
    <b-container fluid class="mt--7">
      <b-row class="justify-content-center">
        <b-col lg="12">
          <b-card no-body header-classes="bg-transparent px-0">
            <b-card-header>
              <h2 slot="header" class="mb-0">สร้างงาน</h2>
            </b-card-header>
            <b-card-body>
              <ValidationObserver ref="observer">
                <b-form @submit="onSubmit">
                  <b-row class="mb-3">
                    <b-col cols="12">
                      <h3>ข้อมูลลูกค้า/บริษัท</h3>
                    </b-col>
                  </b-row>
                  <JobCustomer
                    :form="form"
                    @getCustomerRoutes="getCustomerRoutes" />
                  <hr class="my-3" />
                  <JobDriver :form="form" />
                  <!-- <b-row>
                  <b-col lg="6" cols="12" v-if="form.rate_type === 'custom'">
                    <b-form-group label="ประเภทรถ">
                      <b-form-select v-model="form.vehicle_type_id">
                        <b-form-select-option
                          v-for="(type, i) in vehicle_type"
                          :key="type.id"
                          :value="type.id"
                          >{{ type.name }}</b-form-select-option
                        >
                      </b-form-select>
                    </b-form-group>
                  </b-col>
                </b-row> -->
                  <!-- <b-row v-if="form.rate_type === 'system'">
                  <b-col lg="6" cols="12">
                    <b-form-group label="เลือกเรทราคา">
                      <multiselect
                        :disabled="!form.customer"
                        v-model="form.rate"
                        deselect-label="Can't remove this value"
                        track-by="id"
                        label="name"
                        placeholder="ค้นหาเรทราคา"
                        :options="customer_rates"
                        :allow-empty="false"
                        @select="getRateByOne">
                      </multiselect>
                    </b-form-group>
                  </b-col>
                </b-row> -->
                  <hr class="my-3" />
                  <b-row class="mt-4">
                    <b-col cols="12">
                      <h3>รายละเอียดงาน</h3>
                    </b-col>
                    <b-col lg="12" cols="12" class="card-border-radius p-4">
                      <JobOrderDetail :form="form" @calRate="calRate()" />
                    </b-col>
                  </b-row>
                  <hr class="my-3" />
                  <CategoryRoute
                    ref="customerCategoryRoutes"
                    :form="form"
                    @setRoutes="setRoutes" />
                  <b-row class="mt-4">
                    <b-col lg="12" cols="12" class="card-border-radius px-0">
                      <JobRoute :form="form" :category="false" />
                    </b-col>
                  </b-row>
                  <b-row class="mt-4">
                    <b-col lg="12" cols="12" class="card-border-radius px-0">
                      <AdditionalWork :form="form" @calRate="calRate()" />
                    </b-col>
                  </b-row>
                  <b-row class="mt-4 justify-content-end">
                    <b-col lg="6" cols="12" class="card-border-radius p-4">
                      <CalPrice :form="form" @calRate="calRate()" />
                    </b-col>
                  </b-row>
                  <hr class="my-4" />
                  <div class="d-flex justify-content-between">
                    <base-button
                      type="secondary"
                      class=""
                      @click="
                        $router.push({
                          name: 'manageJob',
                        })
                      ">
                      ย้อนกลับ
                    </base-button>
                    <b-button type="submit" variant="success" class="px-5"
                      >ยืนยัน</b-button
                    >
                  </div>
                </b-form>
              </ValidationObserver>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import rateServices from "@/api/rate.service.js";
import jobServices from "@/api/job.service.js";
import vehicleTypeServices from "@/api/vehicle-type.service.js";
import JobCustomer from "./components/JobCustomer.vue";
import JobDriver from "./components/JobDriver.vue";
import CategoryRoute from "./components/CategoryRoute.vue";
import JobOrderDetail from "./components/JobOrderDetail.vue";
import AdditionalWork from "./components/AdditionalWork.vue";
import CalPrice from "./components/CalPrice.vue";
import JobRoute from "./components/JobRoute.vue";
import { TYPE_QUOTATION } from "@/util/constants.js";
import downloadImage from "@/util/downloadImage.js";
import { modalSuccess, modalError } from "@/util/alert.js";
import { ValidationObserver, ValidationProvider } from "vee-validate";

export default {
  components: {
    JobCustomer,
    JobDriver,
    CategoryRoute,
    JobOrderDetail,
    AdditionalWork,
    CalPrice,
    JobRoute,
    ValidationObserver,
    ValidationProvider,
  },
  props: {},
  data() {
    return {
      downloadImage,
      vehicle_type: [],
      perliters_prices: [],
      customer_rates: [],
      customer_rate_seleted: [],
      form: {
        routes: [],
        categoryRoutes: [],
        job_name: "",
        customer: null,
        driver: null,
        driverDateStart: null,
        driverDateEnd: null,
        category: {
          id: "",
        },
        rate_type: null,
        rate: "",
        distance: "",
        price_perliter: "",
        sale_price: "",
        vehicle_type_id: null,
        fee: "",
        price_service_fee: "",
        price_after_service_fee: "",
        discount: "",
        price_discount: "",
        price_after_discount: "",
        rate_before_vat: 0,
        checkVat: "",
        vatPercent: 7,
        vat: 0,
        price_vat: "",
        check_withholding_tax: "",
        withholdingTaxPercent: 3,
        withholdingTax: 0,
        net: 0,
        fuel_price_id: null,
        additional_work: [{ detail: "", rate: "" }],
      },
      jobDetails: {
        job_name: "",
        startDate: "",
        endDate: "",
      },
    };
  },
  async created() {
    this.getVehicleType();
  },
  methods: {
    // resetFormCal() {
    //   this.perliters_prices = [];
    //   this.form.customer = "";
    //   this.form.rate = "";
    //   this.form.distance = "";
    //   this.form.price_perliter = "";
    //   this.form.sale_price = "";
    //   this.form.net = 0;
    //   this.form.fuel_price_id = null;
    //   this.form.vehicle_type_id = null;
    // },
    calRate() {
      // if (this.form.rate_type === "custom") {
      this.form.rate_before_vat = +this.form.sale_price;
      this.form.additional_work.forEach((work) => {
        if (!isNaN(work.rate)) {
          this.form.rate_before_vat += +work.rate;
        }
      });
      // } else {
      //   const findDistance = this.customer_rate_seleted.find(
      //     (dis) =>
      //       +this.form.distance >= +dis.start && +this.form.distance <= +dis.end
      //   );
      //   if (!findDistance) {
      //     this.form.fuel_price_id = null;
      //     this.form.sale_price = "ไม่พบเรทราคา";
      //     return;
      //   }
      //   const findFuelPrices = findDistance.fuel_prices.find(
      //     (f) => +this.form.price_perliter == +f.price_perliter
      //   );
      //   if (!findFuelPrices) {
      //     this.form.fuel_price_id = null;
      //     this.form.sale_price = "ไม่พบเรทราคา2";
      //     return;
      //   }
      //   this.form.fuel_price_id = findFuelPrices.id;
      //   this.form.sale_price = findFuelPrices.sale_price;
      // }
      this.calServiceFee();
      this.calDiscountPrice();
      this.calVat();
      this.calWithholdingTax();
      this.calNet();
      // this.form.net =
      //   +this.form.net_before_vat + +this.form.vat - +this.form.withholdingTax;
    },
    calNet() {
      const rateBoforeVat = +this.form.rate_before_vat;
      const priceServiceFee = +this.form.price_service_fee;
      const priceDiscount = +this.form.price_discount;
      const priceVat = this.form.vat;
      const withholdingTax = this.form.withholdingTax;
      this.form.net =
        rateBoforeVat +
        priceServiceFee -
        priceDiscount +
        priceVat -
        withholdingTax;
    },
    calServiceFee() {
      if (isNaN(this.form.fee) || this.form.fee < 1) {
        this.form.price_service_fee = "";
        this.form.price_after_service_fee = "";
        return;
      }
      this.form.price_service_fee =
        +this.form.rate_before_vat * (this.form.fee / 100);
      this.form.price_after_service_fee =
        +this.form.rate_before_vat + +this.form.price_service_fee;
    },
    calDiscountPrice() {
      if (isNaN(this.form.discount) || this.form.discount < 1) {
        this.form.price_discount = "";
        this.form.price_after_discount = "";
        return;
      }
      this.form.price_discount =
        (+this.form.rate_before_vat + +this.form.price_service_fee) *
        (+this.form.discount / 100);

      this.form.price_after_discount =
        +this.form.rate_before_vat +
        +this.form.price_service_fee -
        +this.form.price_discount;
    },
    calVat() {
      const vatPercent = +this.form.vatPercent;
      const priceServiceFee = +this.form.price_service_fee;
      const priceDiscount = +this.form.price_discount;
      const rateBeforeVat = +this.form.rate_before_vat;

      if (!this.form.checkVat || isNaN(vatPercent) || vatPercent < 1) {
        this.form.vat = "";
        this.form.price_vat = "";
        return;
      }
      this.form.vat =
        ((rateBeforeVat + priceServiceFee - priceDiscount) * vatPercent) / 100;
      this.form.price_vat =
        this.form.vat + (rateBeforeVat + priceServiceFee - priceDiscount);
    },
    calWithholdingTax() {
      const priceServiceFee = +this.form.price_service_fee;
      const priceDiscount = +this.form.price_discount;
      const rateBeforeVat = +this.form.rate_before_vat;
      const withholdingTaxPercent = +this.form.withholdingTaxPercent;

      if (
        !this.form.check_withholding_tax ||
        isNaN(withholdingTaxPercent) ||
        withholdingTaxPercent < 1
      ) {
        this.form.withholdingTax = "";
        return;
      }

      this.form.withholdingTax =
        ((rateBeforeVat + priceServiceFee - priceDiscount) *
          withholdingTaxPercent) /
        100;
    },
    async getRateByOne(e) {
      this.customer_rate_seleted = [];
      try {
        const response = await rateServices.getRateByOne(e.id);
        if (
          response.data.data &&
          response.data.data.distance_ranges.length > 0
        ) {
          this.customer_rate_seleted = response.data.data.distance_ranges.sort(
            this.compareRanges
          );
          this.perliters_prices =
            response.data.data.distance_ranges[0].fuel_prices.map(
              (p) => p.price_perliter
            );
        }

        this.form.vehicle_type = response.data.data.vehicle_type.name;
      } catch (error) {}
    },
    async getCustomerRoutes(e) {
      await this.$refs.customerCategoryRoutes.getCetegory(e.id);
      // this.setRoutes();
    },
    setRoutes() {
      const index = this.form.categoryRoutes.findIndex(
        (item) => item.id === this.form.category.id
      );

      if (index > -1) {
        this.form.routes =
          this.form.categoryRoutes[index].customer_route_details;
      } else {
        this.form.routes = [];
      }
    },
    async getCustomerRate(e) {
      this.form.rate = "";
      this.form.fuel_price_id = null;
      this.form.vehicle_type_id = null;
      this.customer_rates = [];
      this.customer_rate_seleted = [];
      this.perliters_prices = [];

      await this.getListRateByCustomer(e.id);
    },
    async getListRateByCustomer(customer_id) {
      try {
        const response = await rateServices.getListRateByCustomer(customer_id);
        this.customer_rates = response.data.data;
      } catch (error) {}
    },
    compareRanges(a, b) {
      // เปรียบเทียบตาม start ก่อน
      if (a.start < b.start) {
        return -1;
      }
      if (a.start > b.start) {
        return 1;
      }

      // ถ้า start เท่ากัน ให้เปรียบเทียบตาม end
      if (a.end < b.end) {
        return -1;
      }
      if (a.end > b.end) {
        return 1;
      }

      return 0; // ถ้าทั้ง start และ end เท่ากัน
    },
    async onSubmit(event) {
      event.preventDefault();

      const isValid = await this.$refs.observer.validate();

      if (!isValid) {
        return;
      }

      let routes = this.form.routes;
      if (
        routes.length === 1 &&
        routes[0].name === "" &&
        routes[0].url === ""
      ) {
        routes = null;
      }

      const category = this.form.categoryRoutes.find((item) => {
        return item.id === this.form.category.id;
      });

      let payload = {
        job_name: this.form.job_name,
        customer_id: this.form.customer.id,
        job_rate_type_id: this.form.rate_type,
        oil_price: +this.form.price_perliter,
        service_charge_percent: +this.form.fee, // ค่าบริการ เช่น 3%
        service_charge: +this.form.price_service_fee, // ราคา ค่าบริการ
        price_before_service_charge:
          +this.form.price_after_service_fee - +this.form.price_service_fee,
        price_after_service_charge: +this.form.price_after_service_fee,
        discount_percent: +this.form.discount, // ส่วนลด เช่น 10%
        discount: +this.form.price_discount, //ราคา ส่วนลด หรือ ลดไปเท่าไหร
        price_before_discount:
          +this.form.price_after_discount + +this.form.price_discount,
        price_after_discount: +this.form.price_after_discount, // ราคาหลังหักส่วนลด,
        vat_percent: +this.form.vatPercent, // ภาษีมูลค่าเพิ่ม เช่น 7%
        vat: +this.form.vat, // ราคาของภาษีมูลค่า
        price_vat: +this.form.price_vat, //ราคารวมภาษีมูลค่าเพิ่ม
        withholding_tax_percent: +this.form.withholdingTaxPercent, //หักภาษี ณ ที่จ่าย เช่น 3%
        withholding_tax: +this.form.withholdingTax, //จำนวนเงินของการ หักภาษี ณ ที่จ่าย
        net: +this.form.net, // คือยอดสุทธิ
        distance: +this.form.distance,
        sale_price: +this.form.sale_price, //ราคา ของ ระยะทาง (กม.)
        started_datetime: this.form.driverDateStart,
        ended_datetime: this.form.driverDateEnd,
        customer_route_detail_name: category ? category.name : null,
        job_routes: routes.map((item) => {
          return {
            name: item.name,
            url: item.url,
          };
        }), //เส้นทางการเดินรถ
        job_additational: this.getAdditionalValue(),
        driver_id: this.form.driver ? this.form.driver.id : null,
      };

      // if (this.form.additional_service) {
      //   const serviceValue = this.form.additional_service;
      //   payload[
      //     this.form.additional_service.type ? "serive_charge" : "discount"
      //   ] = serviceValue;
      // }
      try {
        const response = await jobServices.createJob(payload);
        const jobId = response.data.data.id;
        const { data } = await jobServices.getFileUnSignByType({
          job_id: jobId,
          type_name: TYPE_QUOTATION,
        });

        const pdfBlob = data.data;
        this.downloadImage(pdfBlob);

        modalSuccess(this.$bvModal, "สร้างงานสำเร็จ").then(() => {
          this.$router.push({
            name: "manageJob",
          });
        });
      } catch (err) {
        console.log(err);
        modalError(this.$bvModal, "เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง");
      }
    },
    async getVehicleType() {
      try {
        const response = await vehicleTypeServices.getVehicleType();
        this.vehicle_type = response.data.data;
      } catch (error) {}
    },
    getAdditionalValue() {
      if (this.form.additional_work[0].detail === "") {
        return null;
      }
      return this.form.additional_work.map((item) => {
        return {
          name: item.detail,
          price: item.rate,
        };
      });
    },
  },
  mounted() {},
};
</script>

<style scoped></style>
<style lang="scss" scoped></style>
